import { INSIDER_ROLES } from "@/mocks/content";

export default function Insiders() {
  return (
    <section id="insiders" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 text-sm font-bold tracking-[0.25em] text-primary-600">INSIDE · 三类关键角色</p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">谁来告诉你真相</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              知情人士、狗仔现场与娱乐记者，是娱乐圈三扇不同的窗。我们站在三扇窗的交汇处交叉印证。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {INSIDER_ROLES.map((role) => (
            <article
              key={role.role}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-7 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="mb-5 flex items-center justify-between">
                <span className={`flex h-[52px] w-[52px] items-center justify-center rounded-lg text-2xl ${role.bg} ${role.color}`}>
                  <i className={role.icon}></i>
                </span>
                <span className="font-heading text-xs font-bold tracking-[0.2em] text-foreground-300">
                  {role.role.toUpperCase()}
                </span>
              </div>
              <h3 className="font-heading text-xl font-black text-foreground-950">{role.role}</h3>
              <p className={`mt-1 text-sm font-semibold ${role.color}`}>{role.title}</p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{role.desc}</p>
              <ul className="mt-5 flex flex-col gap-2 border-t border-background-200 pt-4">
                {role.points.map((p) => (
                  <li key={p} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className={`${role.color} ri-checkbox-circle-line`}></i>
                    {p}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}